import { useAsync, useDeepCompareEffect } from "@react-hookz/web";
export const useDashboardMessages = messageRenders => {
  const [state, actions] = useAsync(async () => {
    const allSettled = await Promise.allSettled(messageRenders.map(render => render()));
    for (const settled of allSettled) {
      if (settled.status === "rejected" || settled.value === null) continue;
      return settled.value;
    }
  });
  useDeepCompareEffect(() => {
    void actions.execute();
  }, [messageRenders]);
  const message = state.status === "success" ? state.result : undefined;
  return {
    message
  };
};